module.exports = __webpack_public_path__ + "static/media/skyscraper-90560_1920_2.d5d14010.jpg";